<mat-card appearance="outlined" id="login-support-card">
  <mat-toolbar> <span>Passport Support Request</span> </mat-toolbar>
  <mat-card-content>
    <div id="login-form-container">
      @if (formFlag) {
        <form
          novalidate
          id="support-form"
          [formGroup]="supportForm"
          (ngSubmit)="submit()"
          >
          <mat-form-field>
            <input
              id="support-name"
              matInput
              placeholder="Name"
              formControlName="name"
              required
              />
            @if (validate('name', 'required')) {
              <mat-error>
                Name is required
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field>
            <input
              id="support-email"
              matInput
              placeholder="Email"
              formControlName="email"
              required
              />
            @if (validate('email', 'required')) {
              <mat-error>
                Email is required
              </mat-error>
            }
            @if (
              validate('email', 'email') &&
              !validate('email', 'required')
              ) {
              <mat-error
                >
                Value must be a valid email
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field>
            <input
              id="support-phone"
              matInput
              placeholder="Phone"
              formControlName="phone"
              />
            @if (validate('phone', 'pattern')) {
              <mat-error>
                Phone number must be valid, eg: 000-000-0000
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field>
            <mat-select
              id="support-role"
              placeholder="Role"
              formControlName="role"
              required
              >
              <mat-option>--</mat-option>
              @for (role of roles; track role) {
                <mat-option [value]="role">
                  {{ role }}
                </mat-option>
              }
            </mat-select>
            @if (validate('role', 'required')) {
              <mat-error>
                Role is required
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field>
            <input
              id="support-district"
              matInput
              placeholder="District Name"
              formControlName="district"
              required
              />
            @if (validate('district', 'required')) {
              <mat-error>
                District is required
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field>
            <input
              id="support-school"
              matInput
              placeholder="School Name"
              formControlName="school"
              required
              />
            @if (validate('school', 'required')) {
              <mat-error>
                School is required
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field>
            <mat-select
              id="support-language"
              placeholder="Program"
              formControlName="language"
              required
              >
              <mat-option>--</mat-option>
              @for (language of languages; track language) {
                <mat-option
                  [value]="language.languageName"
                  >
                  {{ language.languageName }}
                </mat-option>
              }
            </mat-select>
            @if (validate('language', 'required')) {
              <mat-error>
                Language is required
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field>
            <input
              id="support-course"
              matInput
              placeholder="Class Name"
              formControlName="course"
              />
          </mat-form-field>
          <mat-form-field>
            <input
              id="support-teacher"
              matInput
              placeholder="Teacher's Name"
              formControlName="teacher"
              />
          </mat-form-field>
          <mat-form-field>
            <textarea
              id="support-description"
              matInput
              rows="3"
              placeholder="Description"
              formControlName="description"
              required
            ></textarea>
            @if (validate('description', 'required')) {
              <mat-error>
                Description is required
              </mat-error>
            }
          </mat-form-field>
          <div id="form-buttons" fxLayout="row wrap" fxLayoutAlign="end">
            <button
              id="form-back-button"
              class="back-button support-buttons"
              mat-raised-button
              type="button"
              (click)="goBack()"
              color="secondary"
              >
              Back
            </button>
            <button
              id="submit-button"
              class="support-buttons"
              type="submit"
              mat-raised-button
              [disabled]="supportForm.untouched || !supportForm.valid"
              color="primary"
              >
              Submit
            </button>
          </div>
        </form>
      }
      @if (!formFlag) {
        <div id="status-container">
          @if (sendingFlag) {
            <mat-progress-spinner
              mode="indeterminate"
              color="primary"
              >
            </mat-progress-spinner>
          }
          @if (!sendingFlag && !errors) {
            <p>
              Your support request has been sent.
            </p>
          }
          @if (!sendingFlag && !errors) {
            <p>
              We will respond as soon as possible. If you need immediate
              assistance, please call 800-328-1452 (option 3), or click
              <a href="http://myemcp.com/EMC_Live_Chat" target="_blank"
                >here</a
                >
                to begin a chat with a live agent (business hours only).
                <!-- Remove help center related message
                You
                can find the answer to many frequently asked questions on
                our
                <a href="http://myemcp.com/EMC_Help_Center" target="_blank"
                  >Help Center</a
                  >.
                  -->
                </p>
              }
              @if (!sendingFlag && errors) {
                <p>
                  Passport is experiencing technical difficulties, please try
                  again in 5 minutes.
                </p>
              }
            </div>
          }
        </div>
      </mat-card-content>
      @if (!formFlag) {
        <mat-card-actions>
          @if (!sendingFlag) {
            <button
              id="status-back-button"
              class="back-button"
              fxFill
              mat-raised-button
              type="button"
              (click)="goBack()"
              color="primary"
              >
              Back
            </button>
          }
        </mat-card-actions>
      }
    </mat-card>
